import React, { HTMLAttributes, useEffect, useRef, useState } from "react";

interface ISlideComponentTwo {}

type TSlideComponentTwoProps = ISlideComponentTwo &
  HTMLAttributes<HTMLDivElement>;

const SlideComponentTwo: React.FC<TSlideComponentTwoProps> = (props) => {
  const { ...otherProps } = props;
  const [srcUrl, setSrcUrl] = useState<string | null>(null);

  const videoRef = useRef<HTMLVideoElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setSrcUrl(
            (prev) =>
              prev ??
              `https://dqyerp2t68wdu.cloudfront.net/asgard_freeparking_tutorial.mp4`
          );
          setTimeout(() => videoRef.current?.play().catch(() => {}), 100);
        } else {
          // console.log("should pause video");
          videoRef.current?.pause(); // Pause the video when not visible
        }
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} {...otherProps}>
      <video
        ref={videoRef}
        controls
        className="aspect-video max-w-[640px] w-full"
        muted // Ensure the video is muted
        loop
        playsInline
        src={srcUrl || undefined}
        preload="metadata"
      ></video>
    </div>
  );
};

export default SlideComponentTwo;
